import { ChangeDetectorRef, ElementRef, AfterViewInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { NouisliderComponent } from 'ng2-nouislider';
import { ProductsService } from '../../../shared/services/products.service';
import { Constants } from '../../../shared/config/constants.config';
import { forkJoin } from 'rxjs';
var RecipesFilterModalComponent = /** @class */ (function () {
    function RecipesFilterModalComponent(bsModalRef, constants, changeDetectorRef, productsService) {
        this.bsModalRef = bsModalRef;
        this.constants = constants;
        this.changeDetectorRef = changeDetectorRef;
        this.productsService = productsService;
        this.mobileWidth = 576;
        this.selectedOptions = {};
        this.selectedCategories = [];
        this.hasVideo = false;
        this.mealPrepFriendly = false;
    }
    // tslint:disable-next-line:use-life-cycle-interface
    RecipesFilterModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        forkJoin(this.productsService.getRecipesAttributes(), this.productsService.getRecipeAllCategories()).subscribe(function (_a) {
            var attributes = _a[0], categories = _a[1];
            _this.attributes = attributes;
            _this.recipeCategories = categories;
            _this.changeDetectorRef.markForCheck();
        });
    };
    RecipesFilterModalComponent.prototype.ngAfterViewInit = function () {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    };
    RecipesFilterModalComponent.prototype.onFilter = function () {
        this.recipesComponent.selectedAttributeOptionIds = Object.values(this.selectedOptions);
        this.recipesComponent.selectedCategoryIds = this.selectedCategories;
        this.recipesComponent.hasVideo = this.hasVideo;
        this.recipesComponent.mealPrepFriendly = this.mealPrepFriendly;
        this.bsModalRef.hide();
        this.recipesComponent.reload();
    };
    RecipesFilterModalComponent.prototype.markAttrOption = function (attr_id, option) {
        this.selectedOptions[attr_id] = option.id;
        this.changeDetectorRef.markForCheck();
    };
    RecipesFilterModalComponent.prototype.markCategory = function (category, eventTarget) {
        if (eventTarget.target.checked === true) {
            this.selectedCategories.push(category.id);
        }
        else {
            this.selectedCategories = this.selectedCategories.filter(function (opt) { return opt !== category.id; });
        }
        this.changeDetectorRef.markForCheck();
    };
    RecipesFilterModalComponent.prototype.changeHasVideo = function () {
        this.hasVideo = !this.hasVideo;
        this.changeDetectorRef.markForCheck();
    };
    RecipesFilterModalComponent.prototype.changeMealPrepFriendly = function () {
        this.mealPrepFriendly = !this.mealPrepFriendly;
        this.changeDetectorRef.markForCheck();
    };
    RecipesFilterModalComponent.prototype.toFullscreen = function () {
        var modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        var modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        var modal = this.wrapper.nativeElement.parentElement;
        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    };
    return RecipesFilterModalComponent;
}());
export { RecipesFilterModalComponent };
